import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormIdService {
  private formId = 0;

  getId(): string {
    return `opa-form-${this.formId++}`;
  }
}
